import RectangleModel from "../diagrams/Rectangle/RectangleModel";

export default class PluginRectangleSelection {

    model = new RectangleModel({
        borderColor: 'rgb(224, 39, 133)',
        borderWidth: 3,
        backgroundColor: "transparent",
        borderStyle: 'dashed',
    });

    constructor(designer, {
    } = {}) {

        this.designer = designer;
    }

    install() {

        if (this.designer.mode === "view")
            return;

        const dom = this.designer.dom;
        dom.addEventListener("mousedown", this.onMouseDownHandler = this.onMouseDown.bind(this));
        dom.addEventListener("mouseup", this.onMouseUpHandler = this.onMouseUp.bind(this));
        dom.addEventListener("mousemove", this.onMouseMoveHandler = this.onMouseMove.bind(this));
    }

    uninstall() {

        if (this.designer.mode === "view")
            return;

        const dom = this.designer.dom;
        dom.removeEventListener("mousedown", this.onMouseDownHandler);
        dom.removeEventListener("mouseup", this.onMouseUpHandler);
        dom.removeEventListener("mousemove", this.onMouseMoveHandler);
    }

    onMouseDown(e) {

        if (e.button !== 2)
            return;

        const pt = this.designer.absoluteScreenPointToView({ x: e.clientX, y: e.clientY });
        this.isDragging = true;
        this.backupMouseStart = { x: e.screenX, y: e.screenY };
        this.backupMouseStartView = pt;

        this.model.x = pt.x;
        this.model.y = pt.y;
        this.model.width = 0;
        this.model.height = 0;

        const i = this.designer.adorners.indexOf(this.model);
        if (i < 0)
            this.designer.adorners.push(this.model);

        this.designer.refresh();
    }

    onMouseUp(e) {

        if (e.button !== 2)
            return;

        this.isDragging = false;
        this.backupMouseStart = null;

        const i = this.designer.adorners.indexOf(this.model);
        if (i >= 0)
            this.designer.adorners.splice(i, 1);

        this.designer.refresh();
        this.designer.selectedItems = this.designer.diagrams.reduce((arr, c) => {

            let founds = c.findWithInRectangle(this.model.x, this.model.y, this.model.width.getActualLength(), this.model.height.getActualLength());
            if (founds instanceof Array && founds.length > 0)
                arr = [...arr, ...founds];
            else if (!(founds instanceof Array) && founds)
                arr.push(founds);

            return arr;
        }, []);
    }

    onMouseMove(e) {

        if (!this.isDragging)
            return;

        const pt = this.designer.absoluteScreenPointToView({ x: e.clientX, y: e.clientY });

        let offsetX = pt.x - this.backupMouseStartView.x;
        let offsetY = pt.y - this.backupMouseStartView.y;

        this.model.x = Math.min(pt.x, this.backupMouseStartView.x);
        this.model.y = Math.min(pt.y, this.backupMouseStartView.y);
        this.model.width = Math.abs(offsetX);
        this.model.height = Math.abs(offsetY);

        // console.log(this.model);
    }

}